import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import BuildInstructions from './BuildInstructions';
import { parseUrl, getBuildInstructionByUrl } from '../data/buildInstructions';
import NotFound from './NotFound';

interface BuildInstructionsUrlRouteProps {
    navHeight?: number;
}

/**
 * New URL-based routing component for build instructions
 * Handles the new friendly URL structure:
 * / -> Landing page
 * /kibu-wired-headphones -> Redirect to latest version
 * /kibu-wired-headphones/v1 -> Build instructions for v1
 */
const BuildInstructionsUrlRoute: React.FC<BuildInstructionsUrlRouteProps> = ({ navHeight }) => {
    const location = useLocation();
    const urlResult = parseUrl(location.pathname);

    switch (urlResult.type) {
        case 'landing':
            // This will be handled by the landing page component
            return null;

        case 'redirect':
            return <Navigate to={urlResult.redirectTo} replace />;

        case 'product':
            const buildInstruction = getBuildInstructionByUrl(urlResult.productSlug, urlResult.version);
            if (!buildInstruction) {
                return <NotFound />;
            }

            return (
                <BuildInstructions
                    navHeight={navHeight}
                    navMarginHeight={navHeight}
                    productId={urlResult.internalId}
                    productSlug={urlResult.productSlug}
                    version={urlResult.version}
                />
            );

        case 'not-found':
        default:
            return <NotFound />;
    }
};

export default BuildInstructionsUrlRoute;